'use client' // Hooks must run on the client

import { useState, useEffect } from 'react'

export type Tweet = {
  id: string
  text: string
  created_at: string
  public_metrics: {
    retweet_count: number
    reply_count: number
    like_count: number
  }
}

export function useXFeeds() {
  const [data, setData] = useState<Tweet[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch('/api/tweets')

        if (!res.ok) {
          throw new Error('Failed to fetch feed')
        }

        const json = await res.json()

        if (json.error) {
          throw new Error(json.error)
        }

        setData(json.tweets)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (err: any) {
        setError(err.message)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [])

  return { data, isLoading, error }
}
